// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-content{font-size:14px;color:#273142;text-align:center}.confirm-content .icon-container{margin-bottom:30px}.confirm-content h5{font-size:20px;color:#f27a1a}.confirm-content .button-container>div{margin-bottom:20px}.confirm-content .button-container>div:last-child{margin-bottom:0}.confirm-content .button-container>div .btn{display:block;width:100%;margin:0 auto}", ""]);
// Exports
module.exports = exports;
